<template>
<div>
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class=" container" v-if="!loading">

			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<router-link class="breadcrumb-item" tag="li" :to="`/cars`">Vehículos</router-link>
							<router-link class="breadcrumb-item" tag="li" :to="`/cars/${car.id}`">Vehículo {{car.chassis_number}}</router-link>
							<li class="breadcrumb-item active">Cargos</li>
						</ol>
						<div class="title">
							<h1>Cargos</h1>
						</div>
						<div class="cta text-right">
							<h6 class="m-0">TOTAL</h6>
							<h2><small><small><small>U$S</small></small></small> {{car.chargesTotal}}</h2>

							<div class="btn btn-sm btn-success pull-right mt-4"  @click="newItem()">Agregar cargo</div>
						</div>
					</div>

					<table class="table ">
						<tr class="table-head">
							<td>Detalle</td>
							<td>Adjuntos</td>
							<td class="text-right">Costo</td>
						</tr>
						
						<tr v-for="charge of car.charges" :key="charge.id" >
							<td>{{charge.description}}</td>
							<td><FileList :files="charge.files" size="xs"></FileList></td>
							<td class="text-right">U$S {{charge.price}}</td>
							<td class="text-right">
								<div class="btn btn-xs btn-light" @click="update(charge)"><i class="fa fa-pencil"></i></div>
								<div class="btn btn-xs btn-light" @click="deletePrompt(charge)"><i class="fa fa-times"></i></div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>

	<ChargeForm ref="chargeForm" :carId="car.id" @changed="chargesChanged"></ChargeForm>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import FileList from '@/components/FileList'
import ChargeForm from '@/components/ChargeForm'

export default {
	name: 'CarPreDelivery',
	mixins:[mixins],
	components: {
		Loader,
		Navbar,
		ChargeForm,
		FileList,
	},
	data(){
		return{
			loading: true,
			saving: false,
			API_URL: process.env.VUE_APP_API_URL,
			controlCreated: null,
			car: {},
			key:0
		}
	},
	computed: {
		...mapState(['control'])
	},
	beforeMount(){
		this.load();
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		newItem(){
			this.$refs.chargeForm.open()
		},
		update(charge){
			this.$refs.chargeForm.open(charge.id)
		},
		chargesChanged(){
			this.load()
			console.log('charges changed')
		},
		deletePrompt(charge) {
			this.$dialog
			.confirm('¿Está seguro que desea eliminar este cargo?')
			.then(() => {
				this.delete(charge)
			})
		},
		delete(charge){
			this.$refs.chargeForm.delete(charge.id)
		},
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		load(){
			this.$apollo.query({
				query: gql`query getCar($id: ID!) {
					car(id: $id) {
						id
						chassis_number
						charges{
							id
							description
							price
							files{
								id
								filename
								extension
								type
								url
								urlThumb
							}
						}
						chargesTotal
					}
				}`,
				variables: {
					id: this.$route.params.id,
				},
				fetchPolicy: 'no-cache',
			})
			.then((data) => {
				this.car = data.data.car
				this.loading = false
			})
			.catch(() => {
				// this.$router.push('/')
			})
		},
		async finishControl(){
			if(!this.saving && this.control.charges.length>0 ) {
				this.saving = true
				
				//arreglo charges.
				var charges = []
				this.control.charges.forEach( charge =>{
					charges.push({
						description: charge.description,
						price: charge.price,
						files: charge.files.map(a => a.id)
					})
				})
				let dataInput = {
					car_id 			: this.control.car.id,
					charges			: charges,
				}
				
				return this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlChargesInput! ){
						controlCharges( data: $data) {
							id
							car{
								id
							}
							user{
								name
							}
							type
							typeText
							charges{
								description
								price
							}
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlCharges
					this.saving = false
					this.control.step = 'ControlSuccess'
					this.$bvModal.show('modalSuccess')
				})
				.catch( (error) => {
					this.errors = this.parseGQLErrors(error)
					this.$toast.error('Error!')
					this.saving = false
				})
			}
		},
		close(){
			this.show = false
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
